import { Link } from 'react-router-dom';
import { REQUIRED_QUESTION_COUNT } from '../../shared/assessment';
import { useLanguage } from '../i18n/LanguageContext';

export function HomePage() {
  const { t } = useLanguage();

  return (
    <main id="main-content">
      <section className="hero" id="about">
        <div className="hero-glow" aria-hidden="true" />
        <div className="shell hero-grid">
          <div className="hero-copy">
            <p className="eyebrow eyebrow-gold">{t.hero.eyebrow}</p>
            <h1>{t.hero.title}<br /><em>{t.hero.accent}</em></h1>
            <p className="hero-body">{t.hero.body}</p>
            <div className="hero-actions">
              <Link className="button button-gold" to="/test">{t.hero.primary} <span aria-hidden="true">→</span></Link>
              <a className="text-link" href="/#approach">{t.hero.secondary} <span aria-hidden="true">↓</span></a>
            </div>
            <p className="microcopy"><span aria-hidden="true">◆</span> {t.hero.note}</p>
          </div>
          <div className="hero-brand-card" aria-label="Queen English Academy">
            <div className="hero-brand-halo" aria-hidden="true" />
            <img src="/brand/queen-logo.png" alt="Queen English Academy gold crown and queen chess piece logo" />
            <span className="brand-orbit brand-orbit-one" aria-hidden="true" />
            <span className="brand-orbit brand-orbit-two" aria-hidden="true" />
          </div>
        </div>
        <div className="shell proof-row" aria-label="School highlights">
          {t.proof.map((item) => (
            <div className="proof-item" key={item.label}>
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="section section-light" id="approach">
        <div className="shell">
          <div className="section-heading split-heading">
            <div>
              <p className="eyebrow">{t.approach.eyebrow}</p>
              <h2>{t.approach.title}</h2>
            </div>
            <p>{t.approach.body}</p>
          </div>
          <div className="approach-grid">
            {t.approach.cards.map((card) => (
              <article className="approach-card" key={card.number}>
                <span className="card-number">{card.number}</span>
                <div className="approach-rule" />
                <h3>{card.title}</h3>
                <p>{card.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-ink" id="lessons">
        <div className="shell">
          <div className="section-heading lessons-heading">
            <p className="eyebrow eyebrow-gold">{t.lessons.eyebrow}</p>
            <h2>{t.lessons.title}</h2>
            <p>{t.lessons.body}</p>
          </div>
          <div className="lesson-grid">
            {t.lessons.cards.map((card, index) => (
              <article className={`lesson-card${index === 2 ? ' lesson-card-featured' : ''}`} key={card.title}>
                <div className="lesson-card-header">
                  <span className="lesson-tag">{card.tag}</span>
                  <span className="lesson-price">{card.price}</span>
                </div>
                <h3>{card.title}</h3>
                <p>{card.body}</p>
                <div className="lesson-meta">{card.meta}</div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="teacher-section" id="teacher">
        <div className="shell teacher-grid">
          <div className="teacher-visual">
            <div className="teacher-frame">
              <img src="/brand/teacher.jpg" alt="Queen English Academy teacher" loading="lazy" />
            </div>
            <span className="teacher-caption">Queen English Academy · Online</span>
          </div>
          <div className="teacher-copy">
            <p className="eyebrow">{t.teacher.eyebrow}</p>
            <h2>{t.teacher.title}</h2>
            <p>{t.teacher.body}</p>
            <blockquote>
              <span aria-hidden="true">“</span>
              {t.teacher.quote}
            </blockquote>
            <div className="signature">
              <span />
              <strong>{t.teacher.signature}</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="assessment-cta">
        <div className="shell assessment-panel">
          <div className="assessment-main">
            <p className="eyebrow eyebrow-gold">{t.assessment.eyebrow}</p>
            <h2>{t.assessment.title}</h2>
            <p>{t.assessment.body}</p>
            <ul>
              {t.assessment.points.map((point) => <li key={point}><span aria-hidden="true">✓</span>{point}</li>)}
            </ul>
          </div>
          <div className="assessment-action">
            <span className="assessment-count">{REQUIRED_QUESTION_COUNT}</span>
            <span className="assessment-count-label">Grammar + Vocabulary</span>
            <Link className="button button-gold button-wide" to="/test">{t.assessment.action} <span aria-hidden="true">→</span></Link>
            <p><span aria-hidden="true">◆</span> {t.assessment.privacy}</p>
          </div>
        </div>
      </section>
    </main>
  );
}
